import { motion } from "framer-motion";
import React from "react";

const EASE = [0.76, 0, 0.24, 1];

export const MaskedLine = ({ children, delay = 0, className = "", once = true, initial: initialProp, animate: animateProp }) => {
  const useAutoPlay = !!animateProp;
  const commonProps = useAutoPlay
    ? { initial: initialProp || { y: "110%" }, animate: animateProp }
    : { initial: { y: "110%" }, whileInView: { y: "0%" }, viewport: { once, amount: 0, margin: "0px 0px -10% 0px" } };
  return (
    <span className={`mask-line ${className}`}>
      <motion.span
        style={{ display: "block", willChange: "transform" }}
        {...commonProps}
        transition={{ duration: 1.15, ease: EASE, delay }}
      >
        {children}
      </motion.span>
    </span>
  );
};

export const FadeUp = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0, margin: "0px 0px -10% 0px" }}
    transition={{ duration: 1.1, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);
